"use strict";

buyerBaseService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buyerBaseService = buyerBaseService;
/*@ngInject*/
function buyerBaseService(api) {
    return {
        search: search
    };

    function search(searchString, sellerId) {
        return api.buyerBaseSearch.execute({ search: searchString, sellerId: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/buyerBaseService.js
// module id = 802
// module chunks = 0